export const fuelingDiscovery = `
# Fueling Discovery
</br></br>
Kwik Fill Country contains amazing attractions and destinations, of which some you might not even be aware. The purpose of this page is to show you some of the beautiful places within Kwik Fill Country that are not very far away and easily within a tank of American-made Kwik Fill gasoline.
Interact with this map to discover these Kwik Fill Country Treasures and then plan your visit. We’ll help you plan your route and show you where we are along the way.
</br></br>
<div id="video"> https://www.youtube.com/embed/WeB5-yla2Zs </div>
</br></br>
<img id="image-full" src="/assets/fueling-discovery/sponsor.png" />
</br></br>
<img id="image-full" src="/assets/fueling-discovery/june.png" />
</br></br>
<img id="image-full" src="/assets/fueling-discovery/july.png" />
</br></br>
<img id="image-full" src="/assets/fueling-discovery/august.png" />
</br></br>
<img id="image-full" src="/assets/fueling-discovery/grand.png" />
</br></br>
<img id="image-full" src="/assets/fueling-discovery/spectrum.png" />
</br></br>
<div id="video"> https://www.youtube.com/embed/1IMYDONOfBU </div>
</br></br>`